import { greeting } from '../data/seed';
import { promptsForRole } from '../data/prompts';
import { useAuth } from './AuthProvider';
import { AiTile } from './brand';
import { Composer } from './Composer';

const PANEL_BUBBLES: [number, number, number][] = [
  [-20, 80, 90],
  [40, 220, 50],
  [-10, 360, 36],
];

const FEATURES = [
  { t: 'Track earnings', d: 'Per-Hotspot revenue, trends and projections.', q: 'What are the earnings for Raspy Cobalt Cobra over the past 90 days?' },
  { t: 'Monitor your fleet', d: 'Uptime, status and what needs attention.', q: 'How is my fleet doing?' },
  { t: 'Plan coverage', d: 'Find gaps and target expansion zones.', q: 'Where should we target expansion in Austin?' },
];

export function EmptyHero({
  onSend,
  bubbles,
  draft,
}: {
  onSend: (q: string) => void;
  bubbles: boolean;
  /** Text to open the composer with, editable and not auto-sent. A fresh chat
      opened to continue a closed one arrives here, so the draft lands in the
      hero's composer rather than the thread one. */
  draft?: string;
}) {
  const { user } = useAuth();
  if (!user) return null;
  const chips = promptsForRole(user.role);

  return (
    <div style={{ maxWidth: 860, margin: '0 auto', width: '100%', padding: 'min(7vh,64px) 0 40px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
        <span style={{ fontSize: 'clamp(28px,4vw,40px)', fontWeight: 700, letterSpacing: '-0.03em' }}>
          {greeting()}, {user.first}.
        </span>
      </div>
      <p style={{ fontSize: 18, color: 'var(--fg-2)', margin: '0 0 28px' }}>What would you like to know about the network today?</p>

      {/* dark AI panel */}
      <div
        style={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 24,
          padding: '26px 26px 22px',
          background: 'linear-gradient(135deg, #15171c 0%, #0c0d10 55%, #0a0a0a 100%)',
          color: '#fff',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        {bubbles &&
          PANEL_BUBBLES.map(([t, l, d], i) => (
            <div
              key={i}
              style={{ position: 'absolute', top: t, right: l, width: d, height: d, borderRadius: 999, background: 'rgba(255,255,255,.05)' }}
            />
          ))}
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 18, position: 'relative' }}>
          <AiTile size={46} radius={13} />
          <div>
            <div style={{ fontSize: 19, fontWeight: 700 }}>Helium AI</div>
            <div style={{ fontSize: 14, color: 'rgba(255,255,255,.6)' }}>Ask anything about the Helium Network</div>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 9, marginBottom: 18, position: 'relative' }}>
          {chips.map((c, i) => (
            <button
              key={i}
              onClick={() => onSend(c)}
              className="he-press"
              style={{
                padding: '9px 15px',
                borderRadius: 999,
                background: 'rgba(255,255,255,.07)',
                border: '1px solid rgba(255,255,255,.12)',
                color: 'rgba(255,255,255,.92)',
                fontSize: 13.8,
                fontWeight: 500,
                fontFamily: 'inherit',
                cursor: 'pointer',
                transition: 'background .15s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,.13)')}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,.07)')}
            >
              {c}
            </button>
          ))}
        </div>
        <div style={{ position: 'relative' }}>
          <Composer onSend={onSend} theme="dark" placeholder="Ask Helium AI a question…" autoFocus initialValue={draft} />
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 14, marginTop: 22 }}>
        {FEATURES.map((c, i) => (
          <button
            key={i}
            onClick={() => onSend(c.q)}
            className="he-press he-feature"
            style={{
              textAlign: 'left',
              padding: '18px 18px',
              borderRadius: 16,
              border: 'none',
              background: 'var(--bg-1)',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            <div style={{ fontSize: 15.5, fontWeight: 700, marginBottom: 5 }}>{c.t}</div>
            <div style={{ fontSize: 13.5, color: 'var(--fg-2)', lineHeight: 1.45 }}>{c.d}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
